import {
  Stack,
  TextField,
  InputAdornment,
  Button,
} from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { useState } from "react";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { getAssignments } from "../../api"
import ChooseAssignmentTypeModal from "../modals/ChooseAssignmentTypeModal";
import { AssignmentCard } from "../cards/AssignmentExamCard"
import ListData from "../common/ListData"

const AssignmentsTab = ({ batchId }) => {
  const [search, setSearch] = useState("");
  const [addModal, setAddModal] = useState(false);

  const handleSearchChange = (event) => setSearch(event.target.value);
  const openAddModal = () => setAddModal(true);
  const closeAddModal = () => setAddModal(false);
  const CTA = () => (
      <Stack direction="row" justifyContent="space-between">
        <TextField
          value={search}
          onChange={handleSearchChange}
          placeholder="Search Assignments..."
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon />
              </InputAdornment>
            ),
          }}
        />
        <Button
          onClick={openAddModal}
          variant="contained"
          startIcon={<AddRoundedIcon />}
        >
          Add Assignment
        </Button>
      </Stack>
  )
  return (
    <>
    <ListData
      getAllData={getAssignments}
      initialFilters={batchId && { filter: { batchId: batchId } }}
      HeaderFull={CTA}
      Card={AssignmentCard}
      type="CARD"
      noView
      noFilterSort
    />
      <ChooseAssignmentTypeModal isOpen={addModal} close={closeAddModal} />
    </>
  );
};

export default AssignmentsTab;
